<div class="success-modal">
  <button (click)="close()" class="close-btn">
    <img src="/assets/img/modals/close-btn-black.svg" alt="" />
  </button>

  <h3>Get Special BONUS</h3>

  <img src="/assets/img/tokens-bonus.png" alt="" class="tokens-img" />

  <div class="bottom-row">
    <p>1000 tokens</p>

    <app-button
      class="price-text-size-14"
      [pending]="disableButton"
      (click)="downloadApk()"
    >
      Download APP
    </app-button>
  </div>
</div>
